import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import {
    GENERIC_CATEGORY_LIST_TRANSLATE_BASE,
    STORED_DOCUMENT_PATH,
    STORED_DOCUMENTS_FORM_CATEGORY_ID,
    STORED_DOCUMENTS_FORM_NAME,
} from "@shared/constants/stored-documents.constants";
import { StoredDocumentCategory } from "@shared/models/stored-document-category.model";
import { StoredDocumentEditionForm } from "@shared/models/stored-document-edition-form.model";
import { StoredDocument } from "@shared/models/stored-document.model";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "app-stored-documents-file-edition",
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
    CommonModule,
    DropdownModule,
    InputTextModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: "./stored-documents-file-edition.component.html",
  styleUrl: "./stored-documents-file-edition.component.scss",
})
export class StoredDocumentsFileEditionComponent implements OnChanges {
  @Input() categories: StoredDocumentCategory[] | undefined = undefined;
  @Input() storedDocument: StoredDocument | undefined = undefined;
  @Output() editionValidated = new EventEmitter<StoredDocumentEditionForm>();
  @Output() editionCancelled = new EventEmitter<void>();

  public formGroup!: FormGroup;

  ngOnChanges(changes: SimpleChanges) {
    if (changes[STORED_DOCUMENT_PATH]) {
      this.initializeForm();
    }
  }

  initializeForm() {
    if (this.storedDocument)
      this.formGroup = new FormGroup({
        documentId: new FormControl(this.storedDocument.id, Validators.required),
        name: new FormControl(this.storedDocument.name, [Validators.required, Validators.maxLength(30)]),
        categoryId: new FormControl(this.storedDocument.idCategory, Validators.required),
      });
  }

  get formName() {
    return this.formGroup?.get(STORED_DOCUMENTS_FORM_NAME) as FormControl<string | undefined>;
  }

  get formCategoryId() {
    return this.formGroup?.get(STORED_DOCUMENTS_FORM_CATEGORY_ID) as FormControl<number | undefined>;
  }

  get canValidateEdition(): boolean {
    return this.formName.value !== undefined && this.formCategoryId.value !== undefined;
  }

  validateEdition() {
    this.editionValidated.emit({
      documentId: this.storedDocument!.id,
      name: this.formName.value!,
      categoryId: this.formCategoryId.value!,
    });
  }

  cancelEdition() {
    this.editionCancelled.emit();
  }

  getGenericCategoryTranslationUri(id: string) {
    return GENERIC_CATEGORY_LIST_TRANSLATE_BASE + id;
  }
}
